import * as React from 'react';
import { SystemIconType } from '../types';
/**
 * @deprecated Please use @fiverr-private/visuals package.
 */
const GuaranteeIcon = ({
    size = 16,
    color = 'currentFill'
}: SystemIconType) => (
    <svg width={size}
        height={size}
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
        fill={color}>
        <path d="M7.837.268a.75.75 0 0 1 .326 0l6 1.333a.75.75 0 0 1 .587.732v6c0 2.69-1.732 4.552-3.31 5.692a13.39 13.39 0 0 1-3.119 1.657c-.025.01-.045.016-.059.02l-.017.007-.005.002h-.002L8 15l-.238.711H7.76l-.005-.002-.017-.006-.059-.02a12.697 12.697 0 0 1-.932-.387 13.39 13.39 0 0 1-2.186-1.271c-1.579-1.14-3.311-3.003-3.311-5.692v-6a.75.75 0 0 1 .587-.732l6-1.333ZM8 15l-.238.711a.752.752 0 0 0 .475 0L8 15Zm0-.8a11.892 11.892 0 0 0 2.56-1.392c1.422-1.026 2.69-2.497 2.69-4.475V2.935L8 1.768 2.75 2.935v5.398c0 1.978 1.268 3.45 2.69 4.476A11.89 11.89 0 0 0 8 14.2Z"/>
        <path d="M7.71 3.45v.77a2.9 2.9 0 0 0-1.59.568 1.486 1.486 0 0 0-.57 1.197c-.013.418.134.825.412 1.138.4.385.882.676 1.409.851l.336.13v1.557a5.613 5.613 0 0 1-1.097-.196 5.83 5.83 0 0 1-1.05-.381v1.325c.68.285 1.41.431 2.149.432v1.009h.687v-1.029a2.87 2.87 0 0 0 1.617-.58 1.592 1.592 0 0 0 .578-1.283 1.5 1.5 0 0 0-.196-.77 1.907 1.907 0 0 0-.607-.608 7.704 7.704 0 0 0-1.394-.652V5.444c.554.047 1.097.179 1.61.39l.472-1.174a5.689 5.689 0 0 0-2.08-.462V3.45H7.71Zm0 3.193c-.18-.07-.347-.17-.495-.294a.475.475 0 0 1-.154-.364c0-.284.216-.458.648-.522v1.18Zm.687 1.732c.183.077.356.179.512.302a.452.452 0 0 1 .171.356c0 .318-.228.515-.683.592v-1.25Z"/>
    </svg>
);
GuaranteeIcon.displayName = 'GuaranteeIcon';
export default GuaranteeIcon;
